import {
  Box,
  Container,
  Flex,
  Heading,
  Image,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { benefits } from '../constants';
import type { ISectionItemWithImage } from '../types';
import { Section } from '@/components/shared';

const Benefit: React.FC<ISectionItemWithImage> = (props): JSX.Element => {
  const { content, id, image, srcSet, title } = props;
  return (
    <>
      <Box maxW={{ base: 'full', sm: 300, md: 600 }}>
        <Image alt={id} borderRadius="full" src={image} srcSet={srcSet} />
      </Box>
      <Box maxWidth={650} textAlign={{ base: 'center', md: 'left' }}>
        <Heading
          fontSize={{ base: 'h2.base', md: 'h2.md' }}
          fontWeight="normal"
          mb={{ base: '10px', md: '16px' }}
        >
          {title}
        </Heading>
        <Text fontSize={{ base: 'medium', md: 'large' }}>
          <Trans
            components={{
              ul: <UnorderedList my={{ base: 2, md: 4 }} spacing={1} />,
              li: <ListItem />,
            }}
          >
            {content}
          </Trans>
        </Text>
      </Box>
    </>
  );
};

export const Benefits = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Section
      headingProps={{ mt: { base: 12, md: '120px' } }}
      id="benefits"
      title={t('LANDING.BENEFITS.SECTION_TITLE')}
    >
      <Container maxW="container.xl" px={{ base: 0, md: 4 }} textAlign="center">
        {benefits.map(({ content, title, ...rest }, i) => (
          <Flex
            alignItems="center"
            direction={{ base: 'column', md: i % 2 === 0 ? 'row' : 'row-reverse' }}
            gap={4}
            justifyContent="space-between"
            key={rest.id}
            mb={12}
          >
            <Benefit content={t(content)} title={t(title)} {...rest} />
          </Flex>
        ))}
      </Container>
    </Section>
  );
};
